import { render, staticRenderFns } from "./ResourceCalendarDashboardTab.vue?vue&type=template&id=6229d2ee&scoped=true"
import script from "./ResourceCalendarDashboardTab.vue?vue&type=script&lang=js"
export * from "./ResourceCalendarDashboardTab.vue?vue&type=script&lang=js"
import style0 from "./ResourceCalendarDashboardTab.vue?vue&type=style&index=0&id=6229d2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6229d2ee",
  null
  
)

export default component.exports